<h1 class="page-title">Házasrandi - Alkalmak házaspároknak</h1>

<!--img:Kép egy farsangi alkalomról Egy kép a farsangi alkalomról-->

<p>
  Emlékszünk arra az időszakra, amikor csak randiztunk életünk párjával? Egy finom vacsora mellett órákig beszélgetve... Többek között ezt az időszakot szeretnénk felidézni a házasrandinak elnevezett alkalmainkon keresztül.
</p>

<p>
  A házasság egy életre szóló kaland. Ezt a kalandot osztjuk meg egymással havonta-két havonta egy finom vacsora mellett, játékos illusztrációval vegyítve. Beszélgetéseink gondolat ébresztőek, hogy napról napra többet tudjunk erről az izgalmas elhívásról.
</p>

<p>
A résztvevőknek a következőket tudjuk garantálni:
</p>

<ul>
  <li>Finom vacsora</li>
  <li>Jó társaság</li>
  <li>Jó hangulat</li>
  <li>Jó beszélgetés a házasság különböző területeiről</li>
</ul>

<p><a [routerLink]="['/kapcsolat']">A következő alkalommal kapcsolatban érdeklődj valamelyik elérhetőségünkön!</a></p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/marriage/marriage.component.html